import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const WriteIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 13.25C1 12.8358 1.33579 12.5 1.75 12.5H14.25C14.6642 12.5 15 12.8358 15 13.25C15 13.6642 14.6642 14 14.25 14H1.75C1.33579 14 1 13.6642 1 13.25Z"
		></path>
		<path
			fill="currentColor"
			d="M13.6974 3.76382C14.1009 3.36032 14.1009 2.70613 13.6974 2.30263C13.2939 1.89912 12.6397 1.89912 12.2362 2.30263L11.2997 3.23908L12.7609 4.70028L13.6974 3.76382Z"
		></path>
		<path
			fill="currentColor"
			d="M11.7003 5.76095L10.2391 4.29974L6.05618 8.48271C5.43036 9.10854 5.05485 9.94154 5.00032 10.8249C4.99421 10.9238 5.07614 11.0058 5.17507 10.9997C6.05852 10.9452 6.89159 10.5697 7.51745 9.94384L11.7003 5.76095Z"
		></path>
	</svg>
))
